import { render, staticRenderFns } from "./LeadDistributionView.vue?vue&type=template&id=55c0880d&scoped=true&"
import script from "./LeadDistributionView.vue?vue&type=script&lang=js&"
export * from "./LeadDistributionView.vue?vue&type=script&lang=js&"
import style0 from "./LeadDistributionView.vue?vue&type=style&index=0&id=55c0880d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c0880d",
  null
  
)

export default component.exports